import { Box } from '@mui/material'
import react, { useEffect, useMemo, useReducer } from 'react'

import './styles.css'
import { lockedReducer } from '../Utils/reducers'
import Loader from '../Loader/loader'
import { api } from '../../services/api'
import toast from 'react-hot-toast'
import dayjs from 'dayjs'
import apptheme from '../theme/default'

const url = '/function_log/'

const pooling = 30000
let interval = 0

const pool = async (setState) => {
    const res = await api.get(url + 'dashboard/')
    if (res.status === 200)
        setState({data: res.data})
}

const initialize = async (setState) => {
    setState({ loading: true })
    const [dash, status] = await Promise.all([api.get(url + 'dashboard/'), api.get(url + 'status/')])
    const result = { loading: false }
    if (dash.status === 200) {
        result.data = dash.data
    }
    if (status.status === 200) {
        result.status = status.data
    }
    setState(result)
}

const CategorizeCNPJ = ({ data }) => {

    const category = {}
    if (data.Adicionado)
        data.Adicionado.map(each => {
            switch (each.status) {
                case 'ATIVA':
                    category.active = (category.active || 0) + 1
                    break
                case 'Não encontrado':
                    category.notfound = (category.notfound || 0) + 1
                    break
                case 'BAIXADA':
                    category.cancelled = (category.cancelled || 0) + 1
                    break
                default:
                    break
            }
            category.consult = (category.consult || 0) + 1
        })

    return (
        <>
            <span className='data'><span>CNPJS consultados:</span>        {category.consult || 0} </span>
            <span className='data'><span>CNPJS Ativos:</span>        {category.active || 0} </span>
            <span className='data'><span>CNPJS Cancelados:</span>        {category.cancelled || 0} </span>
            <span className='data'><span>CNPJS Não encontrados:</span>        {category.notfound || 0} </span>
        </>
    )
}

const Dashboard = () => {

    const [state, setState] = useReducer(lockedReducer, {
        data: [],
        status: {},
        loading: false
    })

    useEffect(() => {
        initialize(setState)

        interval = setInterval(() => pool(setState), pooling)
        return () => {
            clearInterval(interval)
        }
    }, [])

    const object_data = useMemo(() => {
        return Object.fromEntries(state.data.map(row => ([row.name, row])))
    }, [state.data])



    return (<>
        <Loader show={state.loading} />
        <Box className='dashboard-mainframe'>
            {object_data.CNPJQuest &&
                <Box className='dashboard-card' sx={{ background: apptheme.primaryColor, color: 'white' }}>
                    <span className='title'><span>Função:</span> Busca de CNPJ's</span>
                    <span className='data'><span>Status:</span> {state.status[object_data.CNPJQuest.state]}</span>
                    <span className='data'><span>Última execução:</span>          {dayjs(object_data.CNPJQuest.created_at).format("DD/MM/YYYY")} </span>
                    <span className='data'><span>Última atualização:</span>       {dayjs(object_data.CNPJQuest.updated_at).format("DD/MM/YYYY")} </span>
                    {<CategorizeCNPJ data={object_data.CNPJQuest.log_content} />}

                </Box>}
            {object_data.import &&
                <Box className='dashboard-card' sx={{ background: apptheme.primaryColor, color: 'white' }}>
                    <span className='title'><span>Função:</span> Importar em massa</span>
                    <span className='data'><span>Status:</span> {state.status[object_data.import.state]}</span>
                    <span className='data'><span>Última execução:</span>         {dayjs(object_data.import.created_at).format("DD/MM/YYYY")} </span>
                    <span className='data'><span>Última atualização:</span>      {dayjs(object_data.import.updated_at).format("DD/MM/YYYY")} </span>
                    <span className='data'><span>CNPJS consultados:</span>       {object_data.import.log_content['Importação completa']} </span>
                </Box>}
            {object_data.export &&
                <Box className='dashboard-card' sx={{ background: apptheme.primaryColor, color: 'white' }}>
                    <span className='title'><span>Função:</span> Exportar em massa</span>
                    <span className='data'><span>Status:</span> {state.status[object_data.export.state]}</span>
                    <span className='data'><span>Última execução:</span>         {dayjs(object_data.export.created_at).format("DD/MM/YYYY")} </span>
                    <span className='data'><span>Última atualização:</span>      {dayjs(object_data.export.updated_at).format("DD/MM/YYYY")} </span>
                    <span className='data'><span>CNPJS consultados:</span>       {object_data.export.log_content['Exportação completa']} </span>
                </Box>}
        </Box>
    </>
    )
}

export default Dashboard